module.exports = __webpack_public_path__ + "static/img/A130.84abef6d.jpg";